import { EventContext, Fields } from '@vimeo/bigpicture-client';

import { createNullObject, PartialWithRequired } from './utils';

export const webBpContextName = 'web_context';
export const webBpContextSchemaVersion = 48;
export type WebBpContext = Fields<typeof webBpContextName, typeof webBpContextSchemaVersion>;

const defaults = createNullObject([
  'location',
  'referrer_page_name',
  'copy',
  'path',
  'referrer',
  'target',
  'target_path',
]);

export const buildWebBpContext = (fields: PartialWithRequired<WebBpContext, 'page_name'>) => {
  return {
    web_context: new EventContext(webBpContextName, webBpContextSchemaVersion, {
      ...defaults,
      ...fields,
    }),
  };
};
